<bk-shell>
  <router-outlet main></router-outlet>
</bk-shell>
<bk-loading-overlay></bk-loading-overlay>
<p-toast
  [preventDuplicates]="true"
  position="top-right"
></p-toast>
